import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class SmsRichPeriodStatistic extends Model {
  day: string;
  slice: string;
  label: string;
  sliceLabel: string;
  timezoneOffset: string;
  count: number;
}

export class SmsRichPeriodStatistics extends Paginated {
  data: Array<SmsRichPeriodStatistic>;
}

export class SmsRichCampainStatistic extends Model {
  total: number;
  os: Os;
  browser: Browser;
  device: Device;
}

export class SmsRichCampainStatistics extends Paginated {
  data: Array<SmsRichCampainStatistic>;
}

export class SmsRichUserStatistic extends Model {
  uniqueClicks: number;
  totalClicks: number;
  sentShortUrls: number;
  percentageClickedOnSent: number;
}

export class Os {
  [key: string]: Value;
}

export class Browser {
  [key: string]: Value;
}

export class Device {
  [key: string]: Value;
}

export class Value {
  clicks: number;
  percentage: number;
}
